/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import { SmartLinkAlignment, SmartLinkDirection, SmartLinkPosition, SmartLinkSize, SmartLinkWidth } from '../../../../../constants';
import { getBaseStyles, getGapSize, renderChildren } from '../utils';
import { getMaxLineHeight, getTruncateStyles } from '../../utils';
const getAlignmentStyles = align => {
  switch (align) {
    case SmartLinkAlignment.Right:
      return css({
        WebkitBoxAlign: 'end',
        MsFlexAlign: 'end',
        justifyContent: 'flex-end',
        textAlign: 'right'
      });
    case SmartLinkAlignment.Left:
    default:
      return css({
        WebkitBoxAlign: 'start',
        MsFlexAlign: 'start',
        justifyContent: 'flex-start',
        textAlign: 'left'
      });
  }
};
const getGapStyles = (size, align) => {
  const gap = getGapSize(size);
  if (align === SmartLinkAlignment.Right) {
    return css({
      '> span': {
        marginLeft: `${gap}rem`
      },
      '> span:first-child': {
        marginLeft: 'initial'
      }
    });
  }
  return css({
    '> span': {
      marginRight: `${gap}rem`,
      '&:last-child': {
        marginRight: 'initial'
      }
    }
  });
};
const getHorizontalDirectionStyles = (size, align) => {
  const lineHeight = getMaxLineHeight(size);
  // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
  return css`
    display: block;
    vertical-align: middle;
    ${getTruncateStyles(1, lineHeight + 'rem')}

    > span, > div {
      vertical-align: middle;

      &[data-smart-element-date-time],
      &[data-smart-element-text] {
        // Show all/wrapped/truncated
        display: inline;
      }
    }

    ${getGapStyles(size, align)}
  `;
};
export const getElementGroupStyles = (direction, size, align, width, position) => css(getBaseStyles(direction, size), getAlignmentStyles(align), {
  minWidth: '10%'
}, width === SmartLinkWidth.Flexible ? `flex: 1 3;` : '', direction === SmartLinkDirection.Horizontal ? getHorizontalDirectionStyles(size, align) : '', position === SmartLinkPosition.Top ? 'align-self: flex-start;' : '');

/**
 * Creates a group of Action components. Accepts an array of Actions, in addition to some styling
 * preferences.
 * @internal
 * @param {ActionGroupProps} ActionGroupProps
 * @see Action
 */
const ElementGroup = ({
  align = SmartLinkAlignment.Left,
  children,
  overrideCss,
  direction = SmartLinkDirection.Horizontal,
  size = SmartLinkSize.Medium,
  testId = 'smart-element-group',
  width = SmartLinkWidth.FitToContent,
  position = SmartLinkPosition.Center
}) => jsx("div", {
  css: [getElementGroupStyles(direction, size, align, width, position), overrideCss],
  "data-smart-element-group": true,
  "data-testid": testId
}, renderChildren(children, size));
export default ElementGroup;